import React, { useState, useEffect } from "react";
import {
  Popconfirm,
  Modal,
  Button,
  Table,
  Form,
  Input,
  Select,
  message,
  Switch,
  Checkbox
} from "antd";

import axios from "axios";
import DefaultLayout from "../components/DefaultLayout";
import CloseButton from "../components/CloseButton";
import Swal from "sweetalert2";
import config from "../config";
import {
  DeleteOutlined,
  EditOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import "./TableSetting.css";
import { set } from "lodash";

const TableSetting = () => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;
  const [filteredTablesData, setFilteredTablesData] = useState([]);
  const [tablesData, setTablesData] = useState([]);
  const [popupModal, setPopupModal] = useState(false);
  const [editTable, setEditTable] = useState(null);
  const [statusOpen, setStatusOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [printerStatusOpen, setPrinterStatusOpen] = useState(false);
  const [printersData, setPrintersData] = useState([]);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handlePrinterStatusDropdownVisibleChange = (open) => {
        setPrinterStatusOpen(open);
    };
  
    const getAllPrinter = async () => {
      try {
        const { data } = await axios.get(`${apiBaseUrl}/api/settings/get-settings`);
        setPrintersData(data.printerSettings.filter(printer => printer.is_counter === true));
      } catch (error) {
        message.error('Something Went Wrong');
        // console.log(error);
      }
    };
  
  const handleStatusDropdownVisibleChange = (open) => {
    setStatusOpen(open);
  };


  const getAllTables = async () => {
    try {
      const { data } = await axios.get(`${apiBaseUrl}/api/tables/get-table`);

      setTablesData(data);
      setFilteredTablesData(data); 
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getAllTables();
    getAllPrinter();
  }, []);

  //search
  const handleSearch = (searchValue) => {
    const lowerSearchValue = searchValue.toLowerCase(); 

    if (searchValue) {
      setFilteredTablesData(
        tablesData.filter(table =>
          table.table_number.toLowerCase().includes(lowerSearchValue)
        )
      );
      console.log("tablesData", tablesData, searchValue);
    } else {
      setFilteredTablesData(tablesData);
    }
  };

  //handle delete
  const handleDelete = async (record) => {
    try {
      await axios.post(`${apiBaseUrl}/api/tables/delete-table`, {
        tableId: record._id,
      });
      // message.success('Table Deleted Successfully')
      Swal.fire({
        title: "Success",
        text: "Table Deleted Successfully",
        toast: true,
        icon: "success",
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });

      getAllTables();
      setPopupModal(false);
    } catch (error) {
      // message.success('Something Went Wrong')
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: error.response.data.message,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  const uniqueCapacities = Array.from(new Set(tablesData.map(t => t.table_capacity))).sort((a, b) => Number(a) - Number(b));
  
  //able data
  const columns = [
    { title: "Table Number", dataIndex: "table_number", sorter: (a, b) => a.table_number.localeCompare(b.table_number, undefined, {numeric: true}), showSorterTooltip: false },
    {
      title: "Table Capacity",
      dataIndex: "table_capacity",
      sorter: (a, b) => Number(a.table_capacity) - Number(b.table_capacity),
      showSorterTooltip: false,
      filters: uniqueCapacities.map(cap => ({ text: cap, value: cap })),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Checkbox.Group
            style={{ display: 'flex', flexDirection: 'column' }}
            options={uniqueCapacities.map(cap => ({ label: cap, value: cap }))}
            value={selectedKeys}
            onChange={(keys) => {
              setSelectedKeys(keys);
              confirm({ closeDropdown: false });
            }}
          />
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: '100%', marginTop: 8 }}
          >
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, record) => record.table_capacity === value,
    },
    {
      title: "Table Status",
      dataIndex: "table_status",
      render: (status) => (status ? "Available" : "Not Available"),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Checkbox.Group
            style={{ display: 'flex', flexDirection: 'column' }}
            options={[
              { label: 'Available', value: true },
              { label: 'Not Available', value: false },
            ]}
            value={selectedKeys}
            onChange={(keys) => {
              setSelectedKeys(keys);
              confirm({ closeDropdown: false });
            }}
          />
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: '100%', marginTop: 8 }}
          >
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, record) => record.table_status === value,
      showSorterTooltip: false
    },
    {
      title: "Is Take Away Table?", dataIndex: "is_take_away_table" ,
      render: (is_take_away_table) => (is_take_away_table ? "Yes" : "No"),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Checkbox.Group
            style={{ display: 'flex', flexDirection: 'column' }}
            options={[
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ]}
            value={selectedKeys}
            onChange={(keys) => {
              setSelectedKeys(keys);
              confirm({ closeDropdown: false });
            }}
          />
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: '100%', marginTop: 8 }}
          >
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, record) => record.is_take_away_table === value,
      showSorterTooltip: false
    },
    {
          title: "Printer",
          dataIndex: "printer",
          filters: printersData.map(p => ({ text: p.name, value: p.id })),
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
              <Checkbox.Group
                style={{ display: 'flex', flexDirection: 'column' }}
                options={printersData.map(p => ({ label: p.name, value: p.id }))}
                value={selectedKeys}
                onChange={(keys) => {
                  setSelectedKeys(keys);
                  confirm({ closeDropdown: false });
                }}
              />
              <Button
                onClick={() => {
                  clearFilters();
                  confirm();
                }}
                size="small"
                style={{ width: '100%', marginTop: 8 }}
              >
                Reset
              </Button>
            </div>
          ),
          onFilter: (value, record) => {
            if (Array.isArray(record.printer)) {
              return record.printer.includes(value);
            }
            return record.printer === value;
          },
          render: (printerIds) => {
            if (!Array.isArray(printerIds)) {
              const printer = printersData.find((p) => p.id === printerIds);
              return printer ? printer.name : "Unknown Printer";
            }
            return printerIds
              .map((id) => printersData.find((p) => p.id === id)?.name || "Unknown Printer")
              .join(", ");
          },
          onCell: () => ({
            style: { verticalAlign: 'top' },
          }),
        },
    { title: "Remark", dataIndex: "remark", sorter: (a,b) => (a.remark || "").localeCompare(b.remark || ""), showSorterTooltip: false },
    {
      title: "Actions",
      dataIndex: "_id",
      render: (id, record) => (
        <div className="action-icons">
          <EditOutlined
            style={{ cursor: "pointer", fontSize: 22, marginRight: 10 }}
            onClick={() => {
              setEditTable(record);
              setPopupModal(true);
            }}
          />
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={() => handleDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined style={{ cursor: "pointer", fontSize: 22, marginLeft: 8 }} />
          </Popconfirm>
        </div>
      ),
      width: 120,
    },
  ];

  const handleCancel = () => {
    if (loading) {
      message.warning("Proceed submitting...");
      return;
    }

    setPopupModal(false);
    setEditTable(null);
  };

  //handle submit
  const handleSubmit = async (value) => {
    setLoading(true);

    if (editTable === null) {
      try {
        const dateTime = new Date();
        const createdAt = dateTime.toLocaleString();
        const newValues = { ...value, createdAt };
        const res = await axios.post(
          `${apiBaseUrl}/api/tables/add-table`,
          newValues
        );
        // message.success('Table Added Successfully');
        Swal.fire({
          title: "Success",
          text: "Table Added Successfully",
          toast: true,
          icon: "success",
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        getAllTables();
        setPopupModal(false);
        setEditTable(null);
      } catch (error) {
        // console.error("Error details:", error);
        if (error.response) {
          // console.error("Response status:", error.response.status);
          // console.error("Response data:", error.response.data);
          if (
            error.response.data.message ===
            "Table with this number already exists"
          ) {
            // message.error('Table with this number already exists');
            Swal.fire({
              icon: "error",
              title: "Duplicate",
              text: "This table number already exists",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
          } else {
            // message.error('Something Went Wrong');
            Swal.fire({
              icon: "error",
              text: "Something Went Wrong",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
          }
        } else {
          // message.error('Network Error');
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Network Error",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const payload = { ...value, tableId: editTable._id };
        // console.log("Payload being sent:", payload);
        await axios.put(`${apiBaseUrl}/api/tables/edit-table`, payload);
        // message.success('Table Updated Successfully');
        Swal.fire({
          title: "Success",
          text: "Table updated successfully",
          icon: "success",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        getAllTables();
        setPopupModal(false);
        setEditTable(null);
      } catch (error) {
        // console.error("Error details:", error);
        if (error.response) {
          // console.error("Response status:", error.response.status);
          // console.error("Response data:", error.response.data);
          if (
            error.response.data.message ===
            "Table with this number already exists"
          ) {
            // message.error('Table with this number already exists');
            Swal.fire({
              icon: "error",
              title: "Duplicate",
              text: "This table number already exists",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
          } else {
            // message.error('Something Went Wrong');
            Swal.fire({
              icon: "error",
              title: "Error",
              text: error.response.data.message,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
          }
        } else {
          // message.error('Network Error');
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Network Error",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <DefaultLayout searchPlaceholder="Table Number" onSearch={handleSearch}>
      <div className={`table-setting-wrapper${popupModal ? ' blur-background' : ''}`}>
        <div className="page-header">
          <h1 className="page-title">Table List</h1>
          <Button type="primary" onClick={() => setPopupModal(true)}>
            Add Table
          </Button>
        </div>
        <Table columns={columns} dataSource={filteredTablesData} bordered 
          //add pagination
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            pageSizeOptions: ['10', '20', '50', '100'],
            showSizeChanger: filteredTablesData.length > 10,
            showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
            onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
          }} 
        />
      </div>
      {/* Modal outside the blurred wrapper so it is not blurred */}
      {popupModal && (
        <Modal
          title={
            <div>
              {editTable !== null ? "Edit Table" : "Add New Table"}
              <CloseButton onClick={handleCancel} />
            </div>
          }
          open={popupModal}
          onCancel={handleCancel}
          footer={false}
        >
          <Form
            layout="vertical"
            initialValues={editTable}
            onFinish={handleSubmit}
          >
            <Form.Item
              name="table_number"
              label="Table Number"
              rules={[
                { required: true, message: "Please input the table number!" },
                {
                  validator: (_, value) => {
                    const isDuplicate = tablesData.some((table) =>
                      table.table_number === value && (!editTable || table._id !== editTable._id)
                    );
                    if (isDuplicate) {
                      return Promise.reject(
                        new Error("This table number already exists!")
                      );
                    }
                    return Promise.resolve();
                  }
                }
              ]}
            >
              <Input type="text" />
            </Form.Item>

            <Form.Item
              name="table_capacity"
              label="Table Capacity"
              rules={[
                { required: true, message: "Please input the table capacity!" },
                {
                  validator: (_, value) => {
                    if (value < 1) {
                      return Promise.reject(
                        new Error("Table capacity must be at least 1!")
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input type="number" min={1} />
            </Form.Item>

            {/* <Form.Item
              name="table_status"
              label="Availability"
              rules={[{ required: true, message: 'Please select the table status!' }]}
            >
              <Select>
                <Select.Option value={true}>Available</Select.Option>
                <Select.Option value={false}>Not Available</Select.Option>
              </Select>
            </Form.Item> */}

            <Form.Item 
              name="is_take_away_table" 
              valuePropName="checked" 
              label="Is Take Away Table?" 
              tooltip="When checked, it means this table is a take away table."
            >
              <Switch />
            </Form.Item>
              <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
                When checked, it means this table is a take away table.
              </div>
            <Form.Item
              name="table_status"
              label="Availability"
              rules={[
                { required: true, message: "Please select the table status!" },
              ]}
            >
              <Select
                onDropdownVisibleChange={handleStatusDropdownVisibleChange}
                suffixIcon={
                  statusOpen ? <CaretUpOutlined /> : <CaretDownOutlined />
                }
              >
                <Select.Option value={true}>Available</Select.Option>
                <Select.Option value={false}>Not Available</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
            name="printer"
            label="Printer"
            rules={[{ required: true, message: 'Please select the printer!' }]}
            >
              <Select
                onDropdownVisibleChange={handlePrinterStatusDropdownVisibleChange}
                suffixIcon={printerStatusOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}            
              >
                {printersData.map((printer) => (
                  <Select.Option key={printer.id} value={printer.id}>
                    {printer.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
                
            <Form.Item
              name="remark"
              label="Remark"
              // Optional remark, so no required rule
            >
              <Input />
            </Form.Item>

            <div className="d-flex justify-content-end ant-modal-footer">
              <Button
                type="primary"
                htmlType="submit"
                loading={loading} // Show loading spinner
                iconPosition="start" // Ensure the icon is positioned at the start
                disabled={loading} // Disable the button while loading
              >
                Save
              </Button>
            </div>
          </Form>
        </Modal>
      )}
    </DefaultLayout>
  );
};

export default TableSetting;
